import { FC } from "react";
import HintText from "./HintText";
import TopBar from "./TopBar";

type AllPipelinesOverviewProps = {
  monitoringGroupId?: string;
}

const AllPipelinesOverview: FC<AllPipelinesOverviewProps> = ({ monitoringGroupId }) => {

  // TODO: "out of order" version. Use the commit 3f589d91 to restore the original functional version.
  return (
    <div className="mx-3 h-full overflow-hidden">
      <TopBar>
        Pipeline Monitoring <sup className="text-brand-violet-400">Beta</sup>
      </TopBar>
      <HintText heading="Monitoring is currently out of order"></HintText>
    </div>
  );
};
export default AllPipelinesOverview;
